import type { IsoAndUnixTimestamp } from "../date-time/iso-and-unix";
import type { HexColor } from "../stylable/hex-color/hex-color";
import type { Label } from "./label";
import type { LabelId } from "./label-id";

const timestamp: IsoAndUnixTimestamp = {
    iso: "2000-01-01T00:00:00.000Z",
    unix: 946684800,
} as IsoAndUnixTimestamp;

const nameLabel: Label = {
    _id: "label__name" as LabelId,
    _type: "LABEL",
    _createdAt: timestamp,
    title: {
        _type: "TRANSLATABLE_VALUE",
        isAutoTranslated: null,
        sv: "Namn",
        en: "Name",
        de: "Name",
    },
    value: "name",
    iconName: "faSignature",
    references: [],
    providerId: null,
    color: "#ffffff" as HexColor,
};

const firstNameLabel: Label = {
    _id: "label__firstName" as LabelId,
    _type: "LABEL",
    _createdAt: timestamp,
    title: {
        _type: "TRANSLATABLE_VALUE",
        isAutoTranslated: null,
        sv: "Förnamn",
        en: "First name",
        de: "Vorname",
    },
    value: "firstName",
    iconName: "faSignature",
    references: [],
    providerId: null,
    color: "#ffffff" as HexColor,
};

const lastNameLabel: Label = {
    _id: "label__lastName" as LabelId,
    _type: "LABEL",
    _createdAt: timestamp,
    title: {
        _type: "TRANSLATABLE_VALUE",
        isAutoTranslated: null,
        sv: "Efternamn",
        en: "Last name",
        de: "Nachname",
    },
    value: "lastName",
    iconName: "faSignature",
    references: [],
    providerId: null,
    color: "#ffffff" as HexColor,
};

const phoneNumberLabel: Label = {
    _id: "label__phoneNumber" as LabelId,
    _type: "LABEL",
    _createdAt: timestamp,
    title: {
        _type: "TRANSLATABLE_VALUE",
        isAutoTranslated: null,
        sv: "Telefonnummer",
        en: "Phone number",
        de: "Telefonnummer",
    },
    value: "phoneNumber",
    iconName: "faPhone",
    references: [],
    providerId: null,
    color: "#ffffff" as HexColor,
};

const emailLabel: Label = {
    _id: "label__email" as LabelId,
    _type: "LABEL",
    _createdAt: timestamp,
    title: {
        _type: "TRANSLATABLE_VALUE",
        isAutoTranslated: null,
        sv: "E-post",
        en: "Email",
        de: "E-Mail",
    },
    value: "email",
    iconName: "faEnvelope",
    references: [],
    providerId: null,
    color: "#ffffff" as HexColor,
};

const defaultLabels = [
    nameLabel,
    firstNameLabel,
    lastNameLabel,
    phoneNumberLabel,
    emailLabel,
] as const;

const defaultLabel: Record<string, Label> = {
    name: nameLabel,
    firstName: firstNameLabel,
    lastName: lastNameLabel,
    phoneNumber: phoneNumberLabel,
    email: emailLabel,
};

export { defaultLabel, defaultLabels };
